import BillLading from '@/components/BillLading/BillLading';
export default {
    name: "collectWriteBillFirstAduit",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
      BillLading
	},
    data() {
        return {
			edit: true,
			showBillLading : true,
			showPdf :false,
            billLadingData: {
                shipper: "shipper input text",
                consignee: "consignee input text",
                notifyParty: "notifyPart input text", ///
                placeOfreceipt: "placeOfreceipt input text",
                vessel: "vessel input text",
                portOfLoading: "portOfLoading input text",
                portOfTransshipment: "portOfTransshipment input text",
                PortOfDischarge: "portOfDischarge input text", ///
                PlaceOfDelivery: "placeOfDelivery input text", //
                freightCharges: "freightAndCharges input text", //
                NoOfOriginal: "noOfOriginal input text", //
                declared: "declared input text",
                voyageNo: "voyageNo input text",
                preCarriageBy: "carriageBy input text", //
                planceAndDate: "planceAndDate input text",
                forwardingAgent: "forAgent input text", //
                signedBy: "",
                typeOfMovement: "typeOfMovement input text",
                blNo: "billNo input text", //
				goodList:[],
				isAddtionalImageDisplay: ''
              },
			writeBillFirstAduitForm: {
				signer:'',
				issuingParty_label:'',
				billingFee:'',
				issuingTime:'',
				portOfDischarge:'',
				payment:'',
				billFormatter: this.$t('c_addWriteBill.billFormatter'),
				billType: this.$t('c_addWriteBill.billType'),
				billAdditionalDescription:'',
				billAdditionalDescriptionOfSend:'',
				sendAuditResult:'',
				sendAuditOpinion:'',
				recFirstAuditResult:'',
				recFirstAuditOpinion:'',
				signAuditResult:'',
				stdContainerNumber:'',
				signAuditOpinion:''
			},
			// 公司下拉列表
			companyList: [],
			imageType: 1,
			// 出单费下拉列表
			costList:[]
        }
	},
	computed: {
		rules() {
			return {
				recFirstAuditResult: [
					{ required: true, //是否必填
					message: this.$t('c_writeBillFirstAduit.validateMassage'), //提示信息
					trigger: 'blur'  //何事件触发
					}
				]	,
			}
		},
		singCompanyList(){
			if(this.writeBillFirstAduitForm.issuingParty_label && this.writeBillFirstAduitForm.signer){
				if(this.writeBillFirstAduitForm.issuingParty_label === this.writeBillFirstAduitForm.signer){
					const id = this.writeBillFirstAduitForm.issuingParty_label;
					return [{id:id, companyName: this.getCompanyName(id)}]
				}else{
					const isId = this.writeBillFirstAduitForm.issuingParty_label;
					const sid = this.writeBillFirstAduitForm.signer;
					return [{id:isId, companyName: this.getCompanyName(isId)},
					{id:sid, companyName: this.getCompanyName(sid)}]
				}
			}
			return [];
		},
		billingFeeCompanyList(){
			let arr = [{
				id: this.conditionData.row.receiveCompanyId,
				companyName: this.conditionData.row.receiveCompanyName
			}];
			if(this.writeBillFirstAduitForm.issuingParty_label && this.writeBillFirstAduitForm.signer){
				if(this.writeBillFirstAduitForm.issuingParty_label === this.writeBillFirstAduitForm.signer){
					const id = this.writeBillFirstAduitForm.issuingParty_label;
					arr.push(...[{id:id, companyName: this.getCompanyName(id)}]);
				}else{
					const isId = this.writeBillFirstAduitForm.issuingParty_label;
					const sid = this.writeBillFirstAduitForm.signer;
					arr.push(...[{id:isId, companyName: this.getCompanyName(isId)},
						{id:sid, companyName: this.getCompanyName(sid)}]);
				}
			}
			return arr;
		},
	},
    methods: {
        init(){
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData.shipper = this.conditionData.row.shipper;
				this.billLadingData.consignee = this.conditionData.row.consignee;
				this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
				this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
				this.billLadingData.vessel = this.conditionData.row.vessel;
				this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
				this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
				this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
				this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
				this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
				this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
				this.billLadingData.declared = this.conditionData.row.declared;
				this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
				this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
				this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
				this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
				this.billLadingData.signedBy = this.conditionData.row.signedBy;
				this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
				this.billLadingData.blNo = this.conditionData.row.blNo;
				this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
				this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
				this.billLadingData.goodList = this.conditionData.row.billGoods;
				this.billLadingData.isAddtionalImageDisplay = this.conditionData.row.isAddtionalImageDisplay;
				this.writeBillFirstAduitForm.signer = this.conditionData.row.signatureCompanyId;
				this.writeBillFirstAduitForm.issuingParty_label = this.conditionData.row.sendCompanyId;
				this.writeBillFirstAduitForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
				this.writeBillFirstAduitForm.issuingTime = this.conditionData.row.sendBillDate;
				this.writeBillFirstAduitForm.portOfDischarge = this.conditionData.row.costId;
				this.writeBillFirstAduitForm.payment = parseInt(this.conditionData.row.payType);
				this.writeBillFirstAduitForm.billAdditionalDescription = this.conditionData.row.billAdditionalDescription;
				this.writeBillFirstAduitForm.billAdditionalDescriptionOfSend = this.conditionData.row.billAdditionalDescriptionOfSend;
				this.writeBillFirstAduitForm.sendAuditResult= this.conditionData.row.scfAuditResult;
				this.writeBillFirstAduitForm.sendAuditOpinion= this.conditionData.row.scfAuditOpinion;
				this.writeBillFirstAduitForm.recFirstAuditResult= this.conditionData.row.rcfAuditResult;
				this.writeBillFirstAduitForm.recFirstAuditOpinion= this.conditionData.row.rcfAuditOpinion;
				this.writeBillFirstAduitForm.signAuditResult= this.conditionData.row.signatureAuditResult;
				this.writeBillFirstAduitForm.signAuditOpinion= this.conditionData.row.signatureAuditOpinion;
				this.writeBillFirstAduitForm.stdContainerNumber= this.conditionData.row.stdContainerNumber;
				// 如果不是wiffa
				if(this.conditionData.row.billImageName !== 'bill_image_wiffa.png'){
					this.imageType = 2;
				}
			}
			// 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
			const selectSendCompanyParam = {};
			selectSendCompanyParam.receiveCompanyId = this.conditionData.row.receiveCompanyId;
			this.$axios({
				method: "get",
				url: "api/customerCompay/selecCompayCustomer", 
				params: selectSendCompanyParam
				}).then(res => {
					this.companyList = res.data.resultData;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: this.$t('common.message.operateFail'),
						type: 'error',
						center: true
					});
				}); 
			// 查询出单费集合下拉
			const param = {};
			// param.isDefault = 0;
			this.$axios.get('/api/cost/selectCostIsDefault',{params:param}).then(response => {
				this.costList = response.data.resultData;
			}).catch(e => {
				console.log(e);
				this.$message({
					message: this.$t('common.message.operateFail'),
					type: 'error',
					center: true
				});
			});
		},
		submitForm(writeBillFirstAduitForm){
			this.$refs[writeBillFirstAduitForm].validate(valid => {
				if (valid) {
					var param = new Object();
					// param.shipper = this.billLadingData.shipper;
					// param.consignee = this.billLadingData.consignee;
					// param.notifyParty = this.billLadingData.notifyParty;
					// param.placeOfreceipt = this.billLadingData.placeOfreceipt;
					// param.vessel = this.billLadingData.vessel;
					// param.portOfLoading = this.billLadingData.portOfLoading;
					// param.portOfTransshipment = this.billLadingData.portOfTransshipment;
					// param.PortOfDischarge = this.billLadingData.PortOfDischarge;
					// param.PlaceOfDelivery = this.billLadingData.PlaceOfDelivery;
					// param.freightCharges = this.billLadingData.freightCharges;
					// param.NoOfOriginal = this.billLadingData.NoOfOriginal;
					// param.declared = this.billLadingData.declared;
					// param.voyageNo = this.billLadingData.voyageNo;
					// param.preCarriageBy = this.billLadingData.preCarriageBy;
					// param.planceAndDate = this.billLadingData.planceAndDate;
					// param.forwardingAgent = this.billLadingData.forwardingAgent;
					// param.signedBy = this.billLadingData.signedBy;
					// param.typeOfMovement = this.billLadingData.typeOfMovement;
					// param.blNo = this.billLadingData.blNo;
					// param.billGoodsList = this.billLadingData.goodList;
					// param.signatureCompanyId = this.writeBillFirstAduitForm.signer;
					// param.sendCompanyId = this.writeBillFirstAduitForm.issuingParty_label;
					// param.sendBillFeeCompanyId = this.writeBillFirstAduitForm.billingFee;
					// param.sendBillDate = this.writeBillFirstAduitForm.issuingTime;
					// param.costId = this.writeBillFirstAduitForm.portOfDischarge;
					// param.payType = this.writeBillFirstAduitForm.payment;
					// param.receiveCompanyId = this.conditionData.row.receiveCompanyId;
					// param.billStatus = this.conditionData.row.billStatus;
					// param.proId = this.conditionData.row.proId;
					param.rcfAuditResult = this.writeBillFirstAduitForm.recFirstAuditResult;
					param.rcfAuditOpinion = this.writeBillFirstAduitForm.recFirstAuditOpinion;
					param.id = this.conditionData.row.id
					param.version = this.conditionData.row.version;
					if(this.writeBillFirstAduitForm.recFirstAuditResult==1){
						param.rcAuditStatus = '1';
					}
					if(this.writeBillFirstAduitForm.recFirstAuditResult==0){
						param.rcAuditStatus = '2';
					}
					this.$axios({
						method: "put",
						url: "api/receipts/recordVerifyUpdate", // 接口地址
						data:param
						}).then(res => {
							console.log();
							if(res.data.status==='1'){
								this.$message({
									message: this.$t('c_addWriteBill.successMassage'),
									type: 'success',
									center: true
								});
								this.$routerUtil.setParam(this.conditionData.searchForm);
								this.$router.push('WriteBillAuditManage');
							}
						}).catch(error => {
							console.log(error);
							this.$message({
								message: 'This is an error message',
								type: 'error',
								center: true
							});
						}); 
				} else {
					console.log('error submit!!')
					return false
				}
			});
		},
		doCancel(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('WriteBillAuditManage');
		},
		getCompanyName(id){
			let companyName = '';
			this.companyList.forEach(item => {
				if(id === item.id){
					companyName = item.companyName;
				}
			});
			return companyName;
		}
    }
}
